import * as L from "leaflet";

import mapJson from "../../../Public/Json/world.geo.json";

// centers of countries
// https://www.google.com/maps/

const mapControls = {
  animEnd: false,
  map: {},
  geoJson: {},
  info: {},
};

const mapState = {
  markers: [],
  filteredMarkers: [],
  filters: {},
};

const leafletOptions = {
  attributionControl: false,
  scrollWheelZoom: false,
  zoomControl: false,
  gestureHandling: true,
  dragging: !L.Browser.mobile,
  nowrap: false,
  gestureHandlingOptions: {
    text: {
      touch:
        "Streichen Sie mit zwei Fingern über die Karte, um sie zu verschieben.",
      scroll: "Benutzen Sie strg + scroll um in die Karte zu zoomen.",
      scrollMac: "Benutzen Sie ⌘ + scroll um in die Karte zu zoomen.",
    },
  },
  zoomSnap: 0.25,
};

const MAP_CONFIG = {
  mapInitialZoom: {
    xs: 1.5,
    md: 2.1,
    xl: 2.4,
    xxl: 2.5,
  },
  mapViewCenter: [20, 0],
  mapViewBounds: [
    [-90, -180],
    [90, 180],
  ],
};

const opacityActiveCountry = (currentCountry) => {
  let val = 0.2;
  mapMarkers.forEach((marker) => {
    if (currentCountry.toLowerCase() === marker.country.toLowerCase()) {
      val = 1.0;
    }
  });
  return val;
};

const fillActiveCountry = (currentCountry) => {
  const colors = {
    default: "#bfd1d7",
    active: "#94c221",
    done: "#045863",
  };

  for (let i = 0; i < mapMarkers.length; i++) {
    if (currentCountry.toLowerCase() === mapMarkers[i].country.toLowerCase()) {
      if (mapMarkers[i].links.findIndex((link) => link.active) !== -1)
        return colors.active;
      else return colors.done;
    }
  }

  return colors.default;
};

/**
 * Initializes map (Partner)
 *
 * @param {String} mapId - map element ID
 * @param {String} locationsEP - locations endpoint (NOTE change to something like "/?type=123&route=locations")
 */
const initMap = (mapId, locationsEP) => {
  let prevScreenWidth = window.innerWidth;

  // // if full map should be visible
  // MAP_CONFIG.mapInitialZoom = {
  //   xs: 2,
  //   md: 1.75,
  //   xl: 1.5,
  //   xxl: 1,
  // };
  // MAP_CONFIG.mapViewCenter = {
  //   xs: [51, 9.9344],
  //   md: [51, 9.5],
  //   xl: [51, 9.5],
  //   xxl: [51, 9.5],
  // };
  // MAP_CONFIG.mapViewBounds = [
  //   [-90, -180],
  //   [90, 180],
  // ];

  const resetHighlight = (e) => {
    mapControls.geojson.resetStyle(e.target);
  };

  const zoomToFeature = (e) => {
    mapControls.map.fitBounds(e.target.getBounds());
  };

  // const onEachFeature = (feature, layer) => {
  //   layer.on({
  //     mouseover: highlightFeature,
  //     mouseout: resetHighlight,
  //     click: zoomToFeature,
  //   });
  // };

  const highlightFeature = (e) => {
    const layer = e.target;

    layer.setStyle({
      fillColor: "#94c221",
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
  };

  /**
   * Updates map view config.
   *
   * @param {Number} screenWidth - normally passed prevScreenWidth from main scope
   */
  const setMapView = (screenWidth) => {
    let screen = screenWidth || window.innerWidth;

    MAP_CONFIG.screen =
      screen < 768 ? "xs" : screen > 1199 ? "xxl" : screen > 991 ? "xl" : "md";
    // console.log("MAP_CONFIG.screen: " + MAP_CONFIG.screen + "(" + screen + ")");
  };

  // ---
  // Retrieve data and generate map

  setMapView();

  mapControls.map = L.map(mapId, {
    ...leafletOptions,
    dragging: prevScreenWidth < 992,
    maxBounds: MAP_CONFIG.mapViewBounds,
    minZoom: MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen],
    maxZoom: MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen] + 1,
  }).setView(
    MAP_CONFIG.mapViewCenter,
    MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen]
  );

  mapControls.geojson = L.geoJson(mapJson, {
    style: function (feature) {
      return {
        opacity: 1,
        color: "#eff0f4",
        weight: 1,
        fillOpacity: opacityActiveCountry(feature.properties["iso_a2"]),
        fillColor: fillActiveCountry(feature.properties["iso_a2"]),
      };
    },
    // onEachFeature: onEachFeature,
  }).addTo(mapControls.map);

  // Resize event handler
  window.addEventListener("resize", function () {
    clearTimeout(this._mtimer);
    this._mtimer = setTimeout(() => {
      if (Math.abs(window.innerWidth - prevScreenWidth) < 99) return;
      prevScreenWidth = window.innerWidth;
      setMapView(prevScreenWidth);
      // mapControls.map.zoomControl.setPosition(
      //   MAP_CONFIG.zoomControlPos[MAP_CONFIG.screen]
      // );
      mapControls.map.setView(
        MAP_CONFIG.mapViewCenter,
        MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen]
      );
    }, 250);
  });

  // Add markers
  mapMarkers.forEach((marker) => {
    // console.log(marker);

    let html = `<div class="marker ${marker.pos}"><span class="pin">${marker.name}</span>`;
    if (marker.links && marker.links.length > 0) {
      let linksOrdered = {
        active: [],
        inactive: [],
      };
      marker.links.forEach((link) => {
        if (link.active) linksOrdered.active.push(link);
        else linksOrdered.inactive.push(link);
      });
      // console.log(marker.country, linksOrdered);

      if (linksOrdered.active.length > 0) {
        html = `<div class="marker ${marker.pos} active"><span class="pin">${marker.name}</span>`;
      }

      html += `<div class="marker-links">`;
      if (linksOrdered.active.length > 0) {
        html += `<div class="mlinklist active-links ${
          linksOrdered.inactive.length > 0 ? "has-inactive-links" : ""
        }">`;
        linksOrdered.active.forEach((link) => {
          html += `<a href="${link.url}" target="_blank" class="active">`;
          if (link.image !== "") html += `<image src="${link.image}"/>`;
          if (link.lineSmall !== "" || link.lineBig !== "") {
            html += `<div class="text">`;
          }
          if (link.lineSmall !== "") {
            html += `<span class="small">${link.lineSmall}</span>`;
          }
          if (link.lineBig !== "") {
            html += `<span class="big">${link.lineBig}</span>`;
          }
          if (link.lineSmall !== "" || link.lineBig !== "") html += `</div>`;
          html += `</a>`;
        });
        html += `</div>`;
      }
      html += `<div class="mlinklist inactive-links">`;
      linksOrdered.inactive.forEach((link) => {
        html += `<a href="${link.url}" target="_blank" class="inactive">`;
        if (link.image !== "") html += `<image src="${link.image}"/>`;
        if (link.lineSmall !== "" || link.lineBig !== "") {
          html += `<div class="text">`;
        }
        if (link.lineSmall !== "") {
          html += `<span class="small">${link.lineSmall}</span>`;
        }
        if (link.lineBig !== "") {
          html += `<span class="big">${link.lineBig}</span>`;
        }
        if (link.lineSmall !== "" || link.lineBig !== "") html += `</div>`;
        html += `</a>`;
      });
      html += `</div>`;
      html += `</div>`;
    }
    html += `</div>`;
    if (!marker.lat || !marker.long) return;
    let lMarker = L.marker([marker.lat, marker.long], {
      icon: new L.DivIcon({
        html: html,
      }),
    })
      // .bindTooltip(marker.title, { direction: "bottom" })
      .addTo(mapControls.map);
    mapState.markers.push(lMarker);
  });
};

export const init = () => {
  if (document.getElementById("map-places")) {
    initMap("map-places", "places");
  }

  let lMarkers = document.querySelectorAll(".leaflet-marker-icon");

  lMarkers.forEach((marker) => {
    let originalZIndex = marker.style.zIndex;

    marker.addEventListener("mouseenter", () => {
      marker.style.zIndex = 10000;
    });
    marker.addEventListener("mouseleave", () => {
      marker.style.zIndex = originalZIndex;
    });
  });
};
